import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { BaseApiUrl } from 'src/app/_services/base-api-urls';

@Injectable({
	providedIn: 'root'
})
export class BigCommerceService {
	public canGenerate$: BehaviorSubject<boolean> = new BehaviorSubject(false);
	public editNewlyGeneratedDesc$: BehaviorSubject<string> = new BehaviorSubject('');

	constructor(private http: HttpClient) {}

	public verifyToken(token: string): Observable<string> {
		return this.http.put<string>(`${BaseApiUrl.Subscription}BAccounts/load/token?token=${token}`, {});
	}

	public getStoreProducts(request: object): Observable<object> {
		return this.http.post<any>(`${BaseApiUrl.Creator}ecommerce/big-commerce/product-retrive`, request);
	}

	public seacrchProducts(request: object): Observable<object> {
		return this.http.post<any>(`${BaseApiUrl.Creator}ecommerce/big-commerce/product-search-retrive`, request);
	}

	public getSortedProducts(request: object): Observable<object> {
		return this.http.post<any>(`${BaseApiUrl.Creator}ecommerce/big-commerce/product-retrive-sort`, request);
	}

	public saveProductDescription(request: object): Observable<object> {
		return this.http.post<any>(`${BaseApiUrl.Creator}ecommerce/big-commerce/product-description-save`, request);
	}

	public getFilterValues(request: object): Observable<object> {
		return this.http.post<any>(`${BaseApiUrl.Creator}ecommerce/big-commerce/product-filter-values`, request);
	}

	public getOptimizedProducts(request: object): Observable<object> {
		return this.http.post<any>(`${BaseApiUrl.Creator}ecommerce/big-commerce/product-optimized-count`, request);
	}

	public downloadBulk(request: object): Observable<object> {
		return this.http.post<any>(`${BaseApiUrl.Creator}ecommerce/big-commerce/product-bulk-download`, request);
	}

	public uploadBulk(request: object): Observable<object> {
		return this.http.post<any>(`${BaseApiUrl.Creator}ecommerce/big-commerce/product-bulk-upload`, request);
	}

	public getPerformingProducts(request: object): Observable<object> {
		return this.http.post<any>(`${BaseApiUrl.Creator}ecommerce/big-commerce/product-performance-metric`, request);
	}

	public getProductsHistory(request: object): Observable<object> {
		return this.http.post<any>(`${BaseApiUrl.Creator}ecommerce/big-commerce/product-history-retrive`, request);
	}

	public getNewlyGenerated(request: object): Observable<object> {
		return this.http.post<any>(`${BaseApiUrl.Creator}ecommerce/big-commerce/product-newly-generated`, request);
	}

	public generateBulk(request: object): Observable<object> {
		return this.http.post<any>(`${BaseApiUrl.Creator}ecommerce/big-commerce/product-bulk-generate`, request);
	}

	public saveBulk(request: object): Observable<object> {
		return this.http.post<any>(`${BaseApiUrl.Creator}ecommerce/big-commerce/product-bulk-save`, request);
	}

	public bulkFlagRetrive(request: object): Observable<object> {
		return this.http.post<any>(`${BaseApiUrl.Creator}ecommerce/big-commerce/bulk-processing-flag-retrieve`, request);
	}

	public bulkFlagReset(request: object): Observable<object> {
		return this.http.post<any>(`${BaseApiUrl.Creator}ecommerce/big-commerce/bulk-processing-popup-reset`, request);
	}

	public editProduct(request: object): Observable<object> {
		return this.http.post<any>(`${BaseApiUrl.Creator}ecommerce/big-commerce/product-generated-edit`, request);
	}
}
